import { FrameBody, Title } from "@npd-ng/adp-benchmark";
import { Button, Container, Form, Spinner, Stack, NavDropdown } from "react-bootstrap";
import { useRef, useState } from "react";
import { Content } from "../types/Content";
import { useSetupCodeValidationService } from "../hooks/useSetupCodeValidationService";
import { actions, assessmentLocation } from "../state";
import { useStateContext } from "../hooks/useStateContext";
import { checkNetworkState } from "../hooks/useNetworkService";
import { resolveNCSDomain } from "../util";
import { useDedupEffect } from "../util/useDedupEffect";
import { useDeviceValidationService } from "../hooks/useDeviceValidationService";
import { postMessageToAdpBridge } from "../hooks/useIPCBridge";
export default function SetupCodeValidationView() {
  const { state, dispatch } = useStateContext();
  const content = state.staticContent as Content;
  const setupCodeContent = content?.deviceReadiness
    .setupCode as Content["deviceReadiness"]["setupCode"];
  const setupCodeElemnts: HTMLInputElement[] = [];
  const inputRef = useRef(setupCodeElemnts);
  const submitRef = useRef<HTMLButtonElement>(null);
  const [layout,setLayout] = useState<"ENG_INTL" | "ENG_US">("ENG_US");
  const [disableSubmit, setDisableSubmit] = useState(
    state.sessionState.providedSetupCode?.length !== 4
  );
  const { validateSetUpCode, resetSchoolDetails, cancelSetupCodeValidation } =
    useSetupCodeValidationService(dispatch, state);
  const {postLocationDeviceMetrics} = useDeviceValidationService(dispatch,state) 
  const getSetupCode = () => {
    const setupcode = inputRef?.current[0]?.value;
    return setupcode?.toUpperCase();
  };
  const onSetupCodeSubmit = () => {
    if (
      state.sessionState.selectedAssessmentMode === "ncs" &&
      resolveNCSDomain()
    ) {
      setDisableSubmit(true);
      validateSetUpCode(getSetupCode());
      return;
    }
    const warning = checkNetworkState();
    if (warning) {
      dispatch(actions.createWarningAction(warning));
      return;
    }
    setDisableSubmit(true);
    validateSetUpCode(getSetupCode());
    };
  const onLocationSubmit = () => {
    if (state?.sessionState?.selectedAssessmentLocation !== undefined) {
      setDisableSubmit(true);
      postLocationDeviceMetrics();
      return;
    }     
    const warning = checkNetworkState();
    if (warning) {
      dispatch(actions.createWarningAction(warning));
      return;
    }
    setDisableSubmit(true);
    dispatch(actions.createLocationErrorAction(true))
  };
  useDedupEffect(() => {
    if (getSetupCode()?.length === 0) {
      inputRef?.current[0]?.focus();
    }
    if(state?.sessionState?.selectedAssessmentLocation !== undefined && inputRef?.current[0]?.value?.length === 4) {
      if(state?.sessionState?.schoolDetails?.assessmentLocations && state?.sessionState?.schoolDetails?.assessmentLocations.length>0){
        setDisableSubmit(false);
      }
    } 
  }, [disableSubmit,state?.sessionState?.schoolDetails?.assessmentLocations, inputRef, state?.sessionState?.selectedAssessmentLocation]);
 useDedupEffect(()=>{
  window.addEventListener('GetKeyboardLayouEvent', (event:any)=>{
    console.log("GetKeyboardLayouEvent",event);
    setLayout(event.detail?.data);
  },{once:true});
 },[])
  const onKeyUp = (e: any) => {
    if (e && e.target) {
      if (e.key === "Backspace" || e.key === "Delete") {
        setDisableSubmit(true);
      } else {
        if (getSetupCode().length === 4) {
          setDisableSubmit(false);
        } else {
          setDisableSubmit(true);
        }
      }
    }
  };
  const onkeyDown = (e: any) => {
 
    /**
     * primitive way of capturing the keyboard layout switch event and sending to extension for storing in the IndexDB
     * temp workaround until API to handle keyboard is released
     * on chromebooks when Space and ctrlKey are pressed space key === "Unidentified"
     * Tip: You can also switch your language by pressing Ctrl + Shift + Space until the language you want is selected. To switch back, press Ctrl + Space.
     */
   // console.log(e.code, e.key,e.ctrlKey,e);
    if(e.nativeEvent && e.nativeEvent?.key === "Unidentified" && e.nativeEvent?.code === "Space"){
      console.log(e.code, e.key,e.ctrlKey,e);
      console.log("keydown","keyboard layout shortcut invoked");
      window.addEventListener('GetKeyboardLayouEvent', (event:any)=>{
        console.log("GetKeyboardLayouEvent",event);
        setLayout(event.detail?.data);
      },{once:true});
      setTimeout(()=>{
        postMessageToAdpBridge({type:"GetKeyboardLayout"}); 
      },500);
    
    }
    else {
      if (!(/[A-Z0-9]/gi.test(e.key) || e.keyCode === 8)) {
        e.preventDefault();
        return;
      }
      if (state.sessionState.schoolDetails?.errorCode) {
        resetSchoolDetails();
      }
    }
  };
  const onCancel = () => {
    cancelSetupCodeValidation();
  };
 const onFocus = () =>{
  window.addEventListener('GetKeyboardLayouEvent', (event:any)=>{
    console.log("GetKeyboardLayouEvent",event);
    setLayout(event.detail?.data);
  },{once:true});
   postMessageToAdpBridge({type:"GetKeyboardLayout"}); 
 }
  const handleChange = (event: { target: { value: string } }) => {
    dispatch(
      actions.createUpdateSchoolAction({
        status: "validating",
        setupCode: event.target.value,
        assessmentLocations : []
      })
    );
    dispatch(actions.createSetAssessmentLocationAction(undefined));
  };
  const onSelect = (eventKey:any, event:any) => {
    event.preventDefault();
    console.log(eventKey) // selected event will trigger
    state?.sessionState?.schoolDetails?.assessmentLocations?.forEach((assessmentLocation:assessmentLocation)=>{
      //We have to store the value as a string in the dropdown so I am matching the selected item with the assessment location label.
      if(assessmentLocation.label === eventKey){
        dispatch(actions.createSetAssessmentLocationAction(assessmentLocation))
        return;
      }
    })
    
  }
  return (
    <Container>
      <FrameBody>
        <Container>
          <Title content={content?.deviceReadiness.title} />
        </Container>
        <Stack direction="horizontal" className="d-grid gap-2">
          {
            <Container id="setupCodeContainer">
              <Stack direction="horizontal" className="setupCodeStack">
                <Stack className="setupInputContainer">
                  <Form.Label className="validationFormLabelField" id="setupCodeLabel" htmlFor="setupcode">
                    {setupCodeContent.title}
                  </Form.Label>
                  <Stack direction="horizontal" className="d-row gap-4">
                    {[1].map((elem, index) => (
                      <Form.Control
                        key={index}
                        type="input"
                        maxLength={4}
                        aria-describedby="setupcodeblock"
                        className="setupCodeInput"
                        ref={(element: HTMLInputElement) => {
                          inputRef.current[index] = element;
                          setupCodeElemnts.push(element);
                        }}
                        onKeyUp={onKeyUp}
                        onKeyDown={onkeyDown}
                        onChange={handleChange}
                        onFocus={onFocus}
                        id={index.toString()}
                        value={
                          state.sessionState.providedSetupCode
                            ? state.sessionState.providedSetupCode
                            : ""
                        }
                      />
                    ))}
                  </Stack>
                </Stack>
                {state?.sessionState?.schoolDetails?.assessmentLocations && state?.sessionState?.schoolDetails?.assessmentLocations.length>0 && (
                    <Stack className="langContainer">
                      <Form.Label id="setupCodeLabel" htmlFor="setupcode">
                        {setupCodeContent.locationTitle}
                      </Form.Label>
                      <NavDropdown
                      className="locationDropdown" 
                      title={state?.sessionState?.selectedAssessmentLocation?.label || "Select a Location"}
                      menuVariant="dark"
                      onSelect={onSelect}
                      >
                        {state?.sessionState?.schoolDetails?.assessmentLocations.map((assessmentLocation)=>{
                          return(
                            <>
                              <NavDropdown.Item className="locationDropdownItem" href={assessmentLocation.label}>{assessmentLocation.label}</NavDropdown.Item>
                            </>
                          )
                        }
                        )}
                      </NavDropdown>
                    </Stack>
                )}
               </Stack>
              <div className="setupCodeStack">
                <Button
                  className="btn-custom btn-custom-primary mr-4"
                  disabled={disableSubmit}
                  variant="primary"
                  size="lg"
                  ref={submitRef}
                  onClick={state?.sessionState?.selectedAssessmentLocation === undefined? onSetupCodeSubmit : onLocationSubmit}
                >
                  { state.deviceReadinessState.validationState === "setupCodeValidation" ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      {content.notifications.verifyingStatus}
                    </>
                  ) : state?.sessionState?.selectedAssessmentLocation === undefined ? content?.actions.submit : content?.actions.continue }
                </Button>{" "}
                <Button
                  className="btn-custom btn-custom-secondary"
                  size="lg"
                  type="button"
                  variant="secondary"
                  onClick={onCancel}
                >
                  {content?.actions.cancel}
                </Button>
                {state.sessionState.schoolDetails?.errorCode && (
                  <Form.Text id="setupcodeblock" muted>
                    <div id="setupCodeErrorText">
                      <span>{setupCodeContent.errorText}</span>
                    </div>
                  </Form.Text>
                )}
                 {layout === "ENG_INTL" && state.appState?.runtimePlatform?.platform!=="Electron" && (
                  <Form.Text id="setupcodeblock" muted>
                    <div id="setupCodeErrorText">
                      <div>{setupCodeContent.international1}</div>
                      <span style={{lineHeight:0,verticalAlign:"top"}}>{setupCodeContent.international2}</span>
                    </div>
                  </Form.Text>
                )}
                {state.sessionState.locationError && (
                  <Form.Text id="setupcodeblock" muted>
                    <div id="setupCodeErrorText">
                      <span>{setupCodeContent.errorText}</span>
                    </div>
                  </Form.Text>
                )}
              </div>
            </Container>
          }
        </Stack>
      </FrameBody>
    </Container>
  );
}
